import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import { LightGalleryProps } from 'lightgallery/react'

import { LightGalleryWrapper } from './light-gallery-wrapper'

export type LightGalleryWrapperDesktopProps = LightGalleryProps & { galleryHeader?: React.ReactNode }

export function LightGalleryWrapperDesktop({ galleryHeader, ...props }: LightGalleryWrapperDesktopProps) {
  return (
    <>
      {galleryHeader}
      <LightGalleryWrapper
        plugins={[lgThumbnail, lgZoom]}
        appendThumbnailsTo=".lg-outer"
        animateThumb={false}
        allowMediaOverlap={true}
        thumbnail={true}
        thumbWidth={124}
        thumbHeight={'104px'}
        counter={false}
        download={false}
        addClass="desktop-light-gallery"
        actualSize={true}
        {...props}
      />
    </>
  )
}
